<ly-icon
  [class]="channelType"
  [icon]="brandDetails.icon"
  [size]="size"
></ly-icon>
